import config from "../config/config";
import virtualWaitingRoomDetailsMock from "../mock/virtualWaitingRoomDetails.json";
import { Patient, VirtualWaitingRoomDetails } from "../types/interfaces";
import { Result } from "../types/result";
import { NameType } from "../types/types";
import { fetchApiResult } from "./apiServices";
import { FailedResult, OkResult } from "./utilities";

export const getPatientName = ({ patient, type }: { patient?: Patient; type?: NameType }) => {
  if (!patient || !patient.name)
    return '';
  const names = patient.name;
  if (!names || names.length == 0)
    return '';
  const name = names[0];
  const givenNames = name.given;
  const lastName = name.family || '';

  if (type == 'Family')
    return lastName;

  const firstName = givenNames && givenNames.length > 0 ? givenNames[0] : '';
  if (type == 'Given')
    return firstName;

  if (!firstName)
    return lastName;
  else if (!lastName)
    return firstName;
  else
    return `${firstName} ${lastName}`;
};

// export const getVirtualWaitingRoomContext = async (token: string): Promise<string> => {
//   const url = `${config.apiConfig.baseUrl}/${config.apiConfig.virtualWaitingRoomContextEndpoint}?token=${token}&asJWE=true`;
//   try {
//     const result = await fetchApiResult<{ context: string }>({
//       url: url
//     });
//     if (!result.ok) {
//       console.error(`Failed to fetch virtual waiting room context: ${result.message}`);
//       return '<Failed to fetch context>';
//     }

//     return result.data!.context;
//   } catch (error) {
//     console.error('Failed to fetch virtual waiting room context:', error);
//     return '<Failed to fetch context>';
//   }
// };

export const getVirtualWaitingRoomDetailsFromContextToken = async (contextToken: string): Promise<Result<VirtualWaitingRoomDetails>> => {
  const url = `${config.apiConfig.baseUrl}/${config.apiConfig.virtualWaitingRoomContextEndpoint}?token=${contextToken}&asJWE=true`;
  try {
    const result = await fetchApiResult<VirtualWaitingRoomDetails>({
      url: url
    });
    return result;
  } catch (error) {
    console.error('Failed to fetch virtual waiting room context:', error);
    return FailedResult(`Failed to fetch virtual waiting room context: ${error}`);
  }
};

export const getVirtualWaitingRoomDetailsFromAPI = async (contextToken: string): Promise<Result<VirtualWaitingRoomDetails>> => {
  const url = `${config.apiConfig.baseUrl}/${config.apiConfig.virtualWaitingRoomDetailsEndpoint}?token=${contextToken}&asJWE=true`;
  try {
    const result = await fetchApiResult<VirtualWaitingRoomDetails>({
      url: url
    });
    return result;
  } catch (error) {
    console.error('Failed to fetch virtual waiting room context:', error);
    return FailedResult(`Failed to fetch virtual waiting room context: ${error}`);
  }
};

export const getVirtualWaitingRoomDetails = async ({ contextToken, mock = false }:
  { contextToken: string, mock?: boolean }
): Promise<Result<VirtualWaitingRoomDetails>> => {
  if (mock) {
    console.warn('Context string is not provided. Using mock virtual waiting room details data.');
    return OkResult(virtualWaitingRoomDetailsMock as VirtualWaitingRoomDetails);
  }
  return await getVirtualWaitingRoomDetailsFromAPI(contextToken);
  // return await getVirtualWaitingRoomDetailsFromContextToken(contextToken);
};  